module.exports = __webpack_public_path__ + "static/media/272.f6b9a30e.png";